import { render, staticRenderFns } from "./open-vip.vue?vue&type=template&id=1a3ef39f&scoped=true"
import script from "./open-vip.vue?vue&type=script&lang=js"
export * from "./open-vip.vue?vue&type=script&lang=js"
import style0 from "./open-vip.vue?vue&type=style&index=0&id=1a3ef39f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3ef39f",
  null
  
)

export default component.exports